import { render, staticRenderFns } from "./OrderReturnControls.vue?vue&type=template&id=71ccd56c"
import script from "./OrderReturnControls.vue?vue&type=script&lang=js"
export * from "./OrderReturnControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports